import { z } from 'zod';

export const TerminalApprovalPolicySchema = z.enum([
  'allowlist',
  'auto-review',
  'run-everything',
]);

export type TerminalApprovalPolicy = z.infer<
  typeof TerminalApprovalPolicySchema
>;

export const TERMINAL_APPROVAL_POLICY_OPTIONS =
  TerminalApprovalPolicySchema.options;

export const DEFAULT_TERMINAL_APPROVAL_POLICY: TerminalApprovalPolicy =
  'allowlist';

export const TerminalApprovalRuleActionSchema = z.enum([
  'allow',
  'ask',
  'deny',
]);

export type TerminalApprovalRuleAction = z.infer<
  typeof TerminalApprovalRuleActionSchema
>;

export const TERMINAL_APPROVAL_RULE_PATTERN_MAX_LENGTH = 200;
export const TERMINAL_APPROVAL_RULES_MAX_COUNT = 200;

export const TerminalApprovalRuleSchema = z.object({
  action: TerminalApprovalRuleActionSchema,
  pattern: z
    .string()
    .trim()
    .min(1)
    .max(TERMINAL_APPROVAL_RULE_PATTERN_MAX_LENGTH),
});

export type TerminalApprovalRule = z.infer<typeof TerminalApprovalRuleSchema>;

export const TerminalApprovalSettingsSchema = z.object({
  policy: TerminalApprovalPolicySchema,
  rules: z
    .array(TerminalApprovalRuleSchema)
    .max(TERMINAL_APPROVAL_RULES_MAX_COUNT),
});

export type TerminalApprovalSettings = z.infer<
  typeof TerminalApprovalSettingsSchema
>;

export const DEFAULT_TERMINAL_APPROVAL_SETTINGS: TerminalApprovalSettings = {
  policy: DEFAULT_TERMINAL_APPROVAL_POLICY,
  rules: [],
};

export const TerminalAutoApprovalSourceSchema = z.enum([
  'rule',
  'auto-review',
  'policy',
]);

export type TerminalAutoApprovalSource = z.infer<
  typeof TerminalAutoApprovalSourceSchema
>;

export const TerminalAutoApprovalSchema = z.object({
  source: TerminalAutoApprovalSourceSchema,
  pattern: z.string().optional(),
  reason: z.string().optional(),
});

export type TerminalAutoApproval = z.infer<typeof TerminalAutoApprovalSchema>;

export const isTerminalApprovalPolicy = (
  value: unknown,
): value is TerminalApprovalPolicy =>
  TerminalApprovalPolicySchema.safeParse(value).success;
